<script setup lang="ts">
import { ModalSize, IconName, ModalIconColor, Modal } from '@exfluential/ui';
import { ref } from 'vue';

const STORAGE_KEY = 'new-dashboard-intro-dismissed';
const SHOW_UNTIL = new Date('2026-10-31T00:00:00Z');

const shouldShow = (): boolean => {
  if (new Date() >= SHOW_UNTIL) return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === null;
  } catch {
    return false;
  }
};

const isOpen = ref(shouldShow());

const rememberDismissal = (): boolean => {
  try {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    return true;
  } catch {
    return false;
  }
};
</script>

<template>
  <Modal
    v-model:open="isOpen"
    persistent
    hide-cancel
    :size="ModalSize.SM"
    :icon="IconName.INFO_CIRCLE"
    :icon-color="ModalIconColor.INFO"
    :title="$t('user-dashboard.modal.title')"
    :description="$t('user-dashboard.modal.description')"
    :confirm-label="$t('user-dashboard.modal.cta')"
    @confirm="rememberDismissal"
  />
</template>
